import PropTypes from 'prop-types'
import { Button } from 'reactstrap'

const propTypes = {
  index                : PropTypes.number,
  onClickSelectUrlType : PropTypes.func,
  buttonText           : PropTypes.string,
  disabled             : PropTypes.bool
}

const UrlTypeButton = ({
  index,
  onClickSelectUrlType,
  buttonText,
  disabled
}) => (
  <>
    <Button
      outline
      onClick={ () => onClickSelectUrlType(index) }
      size='sm'
      color='primary'
      disabled={ disabled }
    >
      { buttonText }
    </Button>
  </>
)

UrlTypeButton.propTypes = propTypes
export default UrlTypeButton
